import { useMemo } from 'react'

import { getAddToCartState } from '@/helpers/getAddToCartState'
import { useAppropriations } from '@/hooks/useAppropriations'
import { useCart } from '@/hooks/useCart'

interface Params {
  productCode?: string
  quantity?: number
  productStock?: string | null
  productPartStatus?: string | null
}

export function useAddToCartState({ productCode, quantity, productStock, productPartStatus }: Params) {
  const { data } = useAppropriations()
  const { cart } = useCart()

  return useMemo(
    () =>
      getAddToCartState({
        appropriations: data?.appropriations,
        cartEntries: cart?.entries,
        productCode,
        quantity,
        productStock,
        productPartStatus,
      }),
    [data?.appropriations, cart?.entries, productCode, quantity, productStock, productPartStatus]
  )
}
